module.exports = __webpack_public_path__ + "img/Providence-College-of-Engineering.a67e103c.jpg";